var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEvent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_40_604",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_40_604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 5.33301H12.6667V3.99967H3.33333V5.33301ZM3.33333 14.6663C2.96667 14.6663 2.65278 14.5358 2.39167 14.2747C2.13056 14.0136 2 13.6997 2 13.333V3.99967C2 3.63301 2.13056 3.31912 2.39167 3.05801C2.65278 2.7969 2.96667 2.66634 3.33333 2.66634H4V1.33301H5.33333V2.66634H10.6667V1.33301H12V2.66634H12.6667C13.0333 2.66634 13.3472 2.7969 13.6083 3.05801C13.8694 3.31912 14 3.63301 14 3.99967V7.78301C13.7889 7.68301 13.5722 7.59967 13.35 7.53301C13.1278 7.46634 12.9 7.41634 12.6667 7.38301V6.66634H3.33333V13.333H7.53333C7.61111 13.5775 7.70278 13.8108 7.80833 14.033C7.91389 14.2552 8.03889 14.4663 8.18333 14.6663H3.33333ZM12 15.333C11.0778 15.333 10.2917 15.008 9.64167 14.358C8.99167 13.708 8.66667 12.9219 8.66667 11.9997C8.66667 11.0775 8.99167 10.2913 9.64167 9.64134C10.2917 8.99134 11.0778 8.66634 12 8.66634C12.9222 8.66634 13.7083 8.99134 14.3583 9.64134C15.0083 10.2913 15.3333 11.0775 15.3333 11.9997C15.3333 12.9219 15.0083 13.708 14.3583 14.358C13.7083 15.008 12.9222 15.333 12 15.333ZM13.1167 13.583L13.5833 13.1163L12.3333 11.8663V9.99967H11.6667V12.133L13.1167 13.583Z",
    fill: "#404040"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvent);
export default __webpack_public_path__ + "static/media/event.860621779f8ff1827402655bcde3c16b.svg";
export { ForwardRef as ReactComponent };